import { EXT } from "./strings2";
import { EXT3 } from "./strings3";
import { EXT4 } from "./strings4";

export const LANGS = ["en", "it", "es", "fr"];
export const LANG_LABELS = { en: "English", it: "Italiano", es: "Español", fr: "Français" };

const en = {
  how: {"eyebrow": "How it works", "title": "Three simple steps", "sub": "No deposits and no booking platforms: just a direct line to the people who will drive you.", "s1t": "Choose your tour", "s1d": "Browse our land tours across Campania and pick the experience that inspires you.", "s2t": "Send your request", "s2d": "Select a date and group size. Your request reaches our team directly, with no online payment.", "s3t": "Confirmed by email or WhatsApp", "s3d": "We reply within a few hours with confirmation, pick-up time and every detail.", "cta": "Browse the tours"},
  extra: {"i4t": "Door-to-door, by land", "i4d": "Hotel pick-ups, no ferries, no waiting at the pier. We drive, you look out of the window.", "stamp": "LAND TOURS • CAMPANIA • HONEST PRICES • ", "badge": "Premium service", "kicker": "No boats. Just the most beautiful roads in Italy."},
  nav: { tours: "Tours", about: "About", contact: "Contact", book: "Book a tour" },
  cat: { all: "All tours", archaeology: "Archaeology", cities: "Cities & Culture", food: "Food & Wine", nature: "Nature & Views", coast: "Coast by Road" },
  card: { from: "From", pp: "per person", discover: "Discover", hours: "{n} hours", max: "Max {n}" },
  hero: {
    eyebrow: "Land tours across Campania",
    title1: "Premium service,",
    title2: "honest prices",
    sub: "Pompeii, Naples, Herculaneum and the Royal Palace of Caserta with licensed archaeologists and local guides. Group, small-group and private tours, by land, with clear prices.",
    explore: "Explore tours",
    plan: "Plan my days",
  },
  intro: {
    eyebrow: "Welcome to AMS Travel",
    title: "Campania by land, done beautifully",
    sub: "We are a team from Naples who know every road, every guide and every family table in the region. We design land tours that feel private and effortless, at prices that make sense.",
  },
  dates: {
    title: "Not sure which day fits?",
    sub: "Tell us your dates and what you love. We'll suggest the best tours for your stay, with prices, within a few hours.",
    name: "Your name", email: "Email", from: "From date", to: "To date", guests: "Guests", howMany: "How many?",
    prefs: "What are you drawn to? (optional)", prefsPh: "Ancient sites, food & wine, views, slow days...",
    send: "Send my dates", sending: "Sending...",
    sentTitle: "Thank you!", sentText: "We received your dates and sent you a confirmation email. We'll reply very soon.",
    pickDate: "Pick a date",
  },
  philosophy: {
    eyebrow: "Our promise",
    title: "Premium service. Honest prices.",
    sub: "Luxury is not a price tag. It's a guide who knows the quiet streets, a driver who is always on time and a lunch where locals eat.",
    i1t: "Licensed local guides", i1d: "Archaeologists, sommeliers and hiking guides from Campania, personally chosen by us.",
    i2t: "Group or private, your choice", i2d: "Shared tours at honest prices or fully private visits with your own guide.",
    i3t: "Fair, transparent prices", i3d: "Clear prices per person or per group, what's included written in black and white. No surprises.",
  },
  featured: {
    eyebrow: "Signature tours",
    title: "The best of Campania, by land",
    sub: "From the streets of Pompeii to the alleys of Naples, from Herculaneum to the Royal Palace of Caserta.",
    viewAll: "View all tours",
  },
  tailor: {
    eyebrow: "Tailor-made",
    title: "Your days, your way",
    text: "Want a private van, a different route or several days combined? Every AMS Travel tour can be customised. Tell us what you dream of, we'll make it simple.",
    cta: "Design my tour",
  },
  trust: {
    s1: "100%", l1: "Land tours", d1: "No boats, no ferries, no weather surprises. Archaeology, art and city life on foot.",
    s2: "14", l2: "Guided tours", d2: "Pompeii, Naples, Herculaneum and Caserta, in group or private form.",
    s3: "From €22", l3: "Per person", d3: "Premium quality at a price that leaves room for one more lunch.",
  },
  final: {
    eyebrow: "Begin your journey",
    title: "Ready to explore Campania?",
    text: "Book online in two minutes or talk to a real person. We reply within hours.",
    plan: "Plan my tour",
    wa: "Chat on WhatsApp",
  },
  tours: {
    eyebrow: "Our tours",
    title: "Land tours across Campania",
    sub: "Fourteen guided tours in Pompeii, Naples, Herculaneum and Caserta. Pick a date and request your booking in two minutes: we confirm by email.",
    empty: "No tours in this category yet.",
    clear: "Show all tours",
    count: "{n} tours",
  },
  detail: {
    back: "All tours", durationL: "Duration", price: "Price", pp: "per person", details: "Details",
    upTo: "Up to {n} guests", duration: "{n} hours", meeting: "Meeting point",
    book: "Book this tour", wa: "WhatsApp", reply: "We reply within a few hours, 8:00 to 21:00 CET",
    experience: "The experience", yourDay: "Your day", included: "What's included", notIncluded: "Not included",
    goodToKnow: "Good to know", faq: "Questions", notFound: "This tour does not exist or is no longer available.",
    gallery: "Gallery",
  },
  booking: {
    title: "Book this tour",
    sub: "Choose your date and guests. No payment now.",
    date: "Date", pickDate: "Choose a date", guests: "Guests",
    name: "Full name", email: "Email", phone: "Phone / WhatsApp", notes: "Notes (optional)",
    notesPh: "Hotel for pick-up, dietary needs, children's ages...",
    total: "Estimated total", perPerson: "{price} × {n} guests",
    submit: "Request booking", submitting: "Sending request...",
    noPayment: "No payment taken online. We check availability and confirm by email within a few hours.",
    successTitle: "Request received!",
    successText: "We've sent a summary to {email}. Your reference is {ref}. You'll get a confirmation email as soon as we've checked availability.",
    another: "Make another booking",
    chat: "Prefer to talk? Chat with a person",
    chooseDate: "Please choose a date",
    remove: "Remove guest", add: "Add guest",
  },
  about: {
    eyebrow: "Our story",
    title: "Born in Naples, made for travellers",
    p1: "AMS Travel was created by a small team of Neapolitans who spent years working with guides, drivers, wineries and family farms across Campania. We saw travellers paying luxury prices for rushed tours, or saving money and missing the soul of the region.",
    p2: "So we chose a different way: only land tours, only people we trust, and prices that stay honest. Every tour is planned as if it were for our own friends.",
    v1t: "Local, always", v1d: "Every guide, driver and host lives in Campania.",
    v2t: "Small and personal", v2d: "Small groups and private options on every tour.",
    v3t: "Honest by design", v3d: "Transparent prices, clear inclusions, real people answering.",
    cta: "See our tours",
  },
  contact: {
    eyebrow: "Get in touch",
    title: "Let's plan your days in Campania",
    sub: "Write to us, call us or chat on WhatsApp. A real person will answer within a few hours.",
    name: "Your name", email: "Email", phone: "Phone (optional)", message: "Your message",
    messagePh: "Dates, number of guests, what you'd love to see...",
    send: "Send message", sending: "Sending...",
    sentTitle: "Message sent!", sentText: "Thank you. We sent you a confirmation email and will reply very soon.",
    phoneL: "Phone", waL: "WhatsApp", emailL: "Email", addressL: "Office", hoursL: "Hours",
    chat: "Chat with a person",
  },
  footer: {
    tagline: "Premium land tours across Campania at honest prices. Pompeii, Naples, Herculaneum and Caserta.",
    tours: "Tours", company: "Company", contact: "Contact",
    rights: "All rights reserved.", motto: "Campania by land",
  },
  wa: {
    aria: "Chat with us on WhatsApp", chat: "Chat with a person",
    default: "Hello AMS Travel! I'd like some information about your tours.",
    tour: "Hello AMS Travel! I'm interested in the tour \"{tour}\". Can you help me?",
  },
  err: { generic: "Something went wrong. Please try again or contact us on WhatsApp.", required: "Please fill in the required fields." },
  notFound: { title: "Page not found", back: "Back to home" },
};

const it = {
  how: {"eyebrow": "Come funziona", "title": "Tre semplici passi", "sub": "Nessun acconto e nessuna piattaforma: un contatto diretto con chi vi accompagnerà.", "s1t": "Scegli il tuo tour", "s1d": "Sfoglia i nostri tour via terra in Campania e scegli l'esperienza che ti ispira.", "s2t": "Invia la richiesta", "s2d": "Seleziona data e numero di persone. La richiesta arriva direttamente al nostro team, senza pagamenti online.", "s3t": "Conferma via email o WhatsApp", "s3d": "Rispondiamo entro poche ore con conferma, orario di partenza e ogni dettaglio.", "cta": "Scopri i tour"},
  extra: {"i4t": "Porta a porta, via terra", "i4d": "Partenza dall'hotel, niente traghetti, niente attese al molo. Guidiamo noi, voi guardate fuori dal finestrino.", "stamp": "TOUR VIA TERRA • CAMPANIA • PREZZI ONESTI • ", "badge": "Servizio premium", "kicker": "Niente barche. Solo le strade più belle d'Italia."},
  nav: { tours: "Tour", about: "Chi siamo", contact: "Contatti", book: "Prenota un tour" },
  cat: { all: "Tutti i tour", archaeology: "Archeologia", cities: "Città e cultura", food: "Cibo e vino", nature: "Natura e panorami", coast: "Costiera in auto" },
  card: { from: "Da", pp: "a persona", discover: "Scopri", hours: "{n} ore", max: "Max {n}" },
  hero: {
    eyebrow: "Tour via terra in tutta la Campania",
    title1: "Servizio premium,",
    title2: "prezzi onesti",
    sub: "Pompei, Napoli, Ercolano e la Reggia di Caserta con archeologi e guide locali abilitate. Tour di gruppo, in piccolo gruppo o privati, via terra, con prezzi chiari.",
    explore: "Scopri i tour",
    plan: "Organizza i miei giorni",
  },
  intro: {
    eyebrow: "Benvenuti in AMS Travel",
    title: "La Campania via terra, fatta con cura",
    sub: "Siamo un team di Napoli che conosce ogni strada, ogni guida e ogni tavola di famiglia della regione. Creiamo tour via terra che sembrano privati e senza pensieri, a prezzi sensati.",
  },
  dates: {
    title: "Non sai quale giorno scegliere?",
    sub: "Dicci le tue date e cosa ami. Ti suggeriremo i tour migliori per il tuo soggiorno, con i prezzi, entro poche ore.",
    name: "Il tuo nome", email: "Email", from: "Dal", to: "Al", guests: "Ospiti", howMany: "Quanti?",
    prefs: "Cosa ti attira? (facoltativo)", prefsPh: "Siti antichi, cibo e vino, panorami, giornate lente...",
    send: "Invia le mie date", sending: "Invio...",
    sentTitle: "Grazie!", sentText: "Abbiamo ricevuto le tue date e ti abbiamo inviato un'email di conferma. Ti risponderemo prestissimo.",
    pickDate: "Scegli una data",
  },
  philosophy: {
    eyebrow: "La nostra promessa",
    title: "Servizio premium. Prezzi onesti.",
    sub: "Il lusso non è un prezzo. È una guida che conosce le strade silenziose, un autista sempre puntuale e un pranzo dove mangiano i locali.",
    i1t: "Guide locali abilitate", i1d: "Archeologi, sommelier e guide escursionistiche campane, scelti personalmente da noi.",
    i2t: "Di gruppo o privato, scegli tu", i2d: "Tour condivisi a prezzi onesti o visite completamente private con la tua guida.",
    i3t: "Prezzi chiari e giusti", i3d: "Prezzi a persona trasparenti, cosa è incluso scritto nero su bianco. Nessuna sorpresa.",
  },
  featured: {
    eyebrow: "Tour d'autore",
    title: "Il meglio della Campania, via terra",
    sub: "Dalle strade di Pompei ai vicoli di Napoli, da Ercolano alla Reggia di Caserta.",
    viewAll: "Vedi tutti i tour",
  },
  tailor: {
    eyebrow: "Su misura",
    title: "I tuoi giorni, a modo tuo",
    text: "Vuoi un van privato, un percorso diverso o più giorni insieme? Ogni tour AMS Travel si può personalizzare. Raccontaci cosa sogni, noi lo rendiamo semplice.",
    cta: "Crea il mio tour",
  },
  trust: {
    s1: "100%", l1: "Tour via terra", d1: "Niente barche, niente traghetti, niente sorprese col meteo. Solo le strade e i sentieri migliori.",
    s2: "14", l2: "Tour guidati", d2: "Pompei, Napoli, Ercolano e Caserta, di gruppo o privati.",
    s3: "Da €22", l3: "A persona", d3: "Qualità premium a un prezzo che lascia spazio a un pranzo in più.",
  },
  final: {
    eyebrow: "Inizia il tuo viaggio",
    title: "Pronto a scoprire la Campania?",
    text: "Prenota online in due minuti o parla con una persona vera. Rispondiamo in poche ore.",
    plan: "Organizza il mio tour",
    wa: "Scrivici su WhatsApp",
  },
  tours: {
    eyebrow: "I nostri tour",
    title: "Tour via terra in tutta la Campania",
    sub: "Quattordici tour guidati a Pompei, Napoli, Ercolano e Caserta. Scegli una data e invia la richiesta in due minuti: confermiamo via email.",
    empty: "Ancora nessun tour in questa categoria.",
    clear: "Mostra tutti i tour",
    count: "{n} tour",
  },
  detail: {
    back: "Tutti i tour", durationL: "Durata", price: "Prezzo", pp: "a persona", details: "Dettagli",
    upTo: "Fino a {n} ospiti", duration: "{n} ore", meeting: "Punto d'incontro",
    book: "Prenota questo tour", wa: "WhatsApp", reply: "Rispondiamo entro poche ore, dalle 8:00 alle 21:00",
    experience: "L'esperienza", yourDay: "La tua giornata", included: "Cosa è incluso", notIncluded: "Non incluso",
    goodToKnow: "Da sapere", faq: "Domande", notFound: "Questo tour non esiste o non è più disponibile.",
    gallery: "Galleria",
  },
  booking: {
    title: "Prenota questo tour",
    sub: "Scegli data e ospiti. Nessun pagamento ora.",
    date: "Data", pickDate: "Scegli una data", guests: "Ospiti",
    name: "Nome e cognome", email: "Email", phone: "Telefono / WhatsApp", notes: "Note (facoltative)",
    notesPh: "Hotel per il pick-up, esigenze alimentari, età dei bambini...",
    total: "Totale stimato", perPerson: "{price} × {n} ospiti",
    submit: "Richiedi prenotazione", submitting: "Invio richiesta...",
    noPayment: "Nessun pagamento online. Verifichiamo la disponibilità e confermiamo via email entro poche ore.",
    successTitle: "Richiesta ricevuta!",
    successText: "Abbiamo inviato un riepilogo a {email}. Il tuo riferimento è {ref}. Riceverai un'email di conferma appena verificata la disponibilità.",
    another: "Fai un'altra prenotazione",
    chat: "Preferisci parlare? Chatta con una persona",
    chooseDate: "Scegli una data",
    remove: "Togli ospite", add: "Aggiungi ospite",
  },
  about: {
    eyebrow: "La nostra storia",
    title: "Nati a Napoli, pensati per chi viaggia",
    p1: "AMS Travel nasce da un piccolo team di napoletani che ha lavorato per anni con guide, autisti, cantine e aziende agricole di tutta la Campania. Vedevamo viaggiatori pagare prezzi di lusso per tour frettolosi, oppure risparmiare e perdersi l'anima della regione.",
    p2: "Così abbiamo scelto un'altra strada: solo tour via terra, solo persone di fiducia e prezzi che restano onesti. Ogni tour è pensato come se fosse per i nostri amici.",
    v1t: "Sempre locali", v1d: "Ogni guida, autista e ospite vive in Campania.",
    v2t: "Piccoli e personali", v2d: "Piccoli gruppi e opzioni private per ogni tour.",
    v3t: "Onesti per scelta", v3d: "Prezzi trasparenti, inclusioni chiare, persone vere che rispondono.",
    cta: "Guarda i nostri tour",
  },
  contact: {
    eyebrow: "Contattaci",
    title: "Organizziamo i tuoi giorni in Campania",
    sub: "Scrivici, chiamaci o chatta su WhatsApp. Una persona vera risponderà entro poche ore.",
    name: "Il tuo nome", email: "Email", phone: "Telefono (facoltativo)", message: "Il tuo messaggio",
    messagePh: "Date, numero di ospiti, cosa ti piacerebbe vedere...",
    send: "Invia messaggio", sending: "Invio...",
    sentTitle: "Messaggio inviato!", sentText: "Grazie. Ti abbiamo inviato un'email di conferma e ti risponderemo prestissimo.",
    phoneL: "Telefono", waL: "WhatsApp", emailL: "Email", addressL: "Ufficio", hoursL: "Orari",
    chat: "Chatta con una persona",
  },
  footer: {
    tagline: "Tour via terra premium in Campania a prezzi onesti. Pompei, Napoli, Ercolano e Caserta.",
    tours: "Tour", company: "Azienda", contact: "Contatti",
    rights: "Tutti i diritti riservati.", motto: "La Campania via terra",
  },
  wa: {
    aria: "Scrivici su WhatsApp", chat: "Chatta con una persona",
    default: "Ciao AMS Travel! Vorrei informazioni sui vostri tour.",
    tour: "Ciao AMS Travel! Sono interessato al tour \"{tour}\". Potete aiutarmi?",
  },
  err: { generic: "Qualcosa è andato storto. Riprova o contattaci su WhatsApp.", required: "Compila i campi obbligatori." },
  notFound: { title: "Pagina non trovata", back: "Torna alla home" },
};

const es = {
  how: {"eyebrow": "Cómo funciona", "title": "Tres pasos sencillos", "sub": "Sin depósitos ni plataformas: un contacto directo con quienes te acompañarán.", "s1t": "Elige tu tour", "s1d": "Explora nuestros tours por tierra en Campania y elige la experiencia que te inspire.", "s2t": "Envía tu solicitud", "s2d": "Selecciona fecha y número de personas. Tu solicitud llega directamente a nuestro equipo, sin pago online.", "s3t": "Confirmación por email o WhatsApp", "s3d": "Respondemos en pocas horas con la confirmación, la hora de recogida y todos los detalles.", "cta": "Ver los tours"},
  extra: {"i4t": "Puerta a puerta, por tierra", "i4d": "Recogida en el hotel, sin ferris ni esperas en el muelle. Nosotros conducimos, tú miras por la ventana.", "stamp": "TOURS POR TIERRA • CAMPANIA • PRECIOS HONESTOS • ", "badge": "Servicio premium", "kicker": "Sin barcos. Solo las carreteras más bonitas de Italia."},
  nav: { tours: "Tours", about: "Nosotros", contact: "Contacto", book: "Reservar un tour" },
  cat: { all: "Todos los tours", archaeology: "Arqueología", cities: "Ciudades y cultura", food: "Comida y vino", nature: "Naturaleza y vistas", coast: "Costa por carretera" },
  card: { from: "Desde", pp: "por persona", discover: "Descubrir", hours: "{n} horas", max: "Máx {n}" },
  hero: {
    eyebrow: "Tours por tierra en toda Campania",
    title1: "Servicio premium,",
    title2: "precios honestos",
    sub: "Pompeya, Nápoles, Herculano y el Palacio Real de Caserta con arqueólogos y guías locales titulados. Tours en grupo, en grupo reducido o privados, por tierra, con precios claros.",
    explore: "Ver tours",
    plan: "Planificar mis días",
  },
  intro: {
    eyebrow: "Bienvenido a AMS Travel",
    title: "Campania por tierra, hecha con mimo",
    sub: "Somos un equipo de Nápoles que conoce cada carretera, cada guía y cada mesa familiar de la región. Diseñamos tours por tierra que se sienten privados y sin esfuerzo, a precios que tienen sentido.",
  },
  dates: {
    title: "¿No sabes qué día elegir?",
    sub: "Cuéntanos tus fechas y lo que te gusta. Te sugeriremos los mejores tours para tu estancia, con precios, en pocas horas.",
    name: "Tu nombre", email: "Email", from: "Desde", to: "Hasta", guests: "Personas", howMany: "¿Cuántos?",
    prefs: "¿Qué te atrae? (opcional)", prefsPh: "Sitios antiguos, comida y vino, vistas, días tranquilos...",
    send: "Enviar mis fechas", sending: "Enviando...",
    sentTitle: "¡Gracias!", sentText: "Hemos recibido tus fechas y te hemos enviado un email de confirmación. Te responderemos muy pronto.",
    pickDate: "Elige una fecha",
  },
  philosophy: {
    eyebrow: "Nuestra promesa",
    title: "Servicio premium. Precios honestos.",
    sub: "El lujo no es un precio. Es un guía que conoce las calles tranquilas, un conductor siempre puntual y un almuerzo donde comen los locales.",
    i1t: "Guías locales titulados", i1d: "Arqueólogos, sumilleres y guías de montaña de Campania, elegidos personalmente por nosotros.",
    i2t: "En grupo o privado, tú eliges", i2d: "Tours compartidos a precios honestos o visitas totalmente privadas con tu propio guía.",
    i3t: "Precios justos y claros", i3d: "Precios por persona transparentes, lo incluido por escrito. Sin sorpresas.",
  },
  featured: {
    eyebrow: "Tours estrella",
    title: "Lo mejor de Campania, por tierra",
    sub: "De las calles de Pompeya a las callejuelas de Nápoles, de Herculano al Palacio Real de Caserta.",
    viewAll: "Ver todos los tours",
  },
  tailor: {
    eyebrow: "A medida",
    title: "Tus días, a tu manera",
    text: "¿Quieres una furgoneta privada, otra ruta o varios días combinados? Todos los tours de AMS Travel se pueden personalizar. Cuéntanos tu sueño, nosotros lo hacemos fácil.",
    cta: "Diseñar mi tour",
  },
  trust: {
    s1: "100%", l1: "Tours por tierra", d1: "Sin barcos, sin ferris, sin sorpresas del tiempo. Solo las mejores carreteras y senderos.",
    s2: "14", l2: "Tours guiados", d2: "Pompeya, Nápoles, Herculano y Caserta, en grupo o privados.",
    s3: "Desde 22 €", l3: "Por persona", d3: "Calidad premium a un precio que deja sitio para otro almuerzo.",
  },
  final: {
    eyebrow: "Empieza tu viaje",
    title: "¿Listo para descubrir Campania?",
    text: "Reserva online en dos minutos o habla con una persona real. Respondemos en pocas horas.",
    plan: "Planificar mi tour",
    wa: "Chatear por WhatsApp",
  },
  tours: {
    eyebrow: "Nuestros tours",
    title: "Tours por tierra en toda Campania",
    sub: "Catorce tours guiados en Pompeya, Nápoles, Herculano y Caserta. Elige una fecha y envía tu solicitud en dos minutos: confirmamos por email.",
    empty: "Todavía no hay tours en esta categoría.",
    clear: "Ver todos los tours",
    count: "{n} tours",
  },
  detail: {
    back: "Todos los tours", durationL: "Duración", price: "Precio", pp: "por persona", details: "Detalles",
    upTo: "Hasta {n} personas", duration: "{n} horas", meeting: "Punto de encuentro",
    book: "Reservar este tour", wa: "WhatsApp", reply: "Respondemos en pocas horas, de 8:00 a 21:00 CET",
    experience: "La experiencia", yourDay: "Tu día", included: "Qué incluye", notIncluded: "No incluido",
    goodToKnow: "Información útil", faq: "Preguntas", notFound: "Este tour no existe o ya no está disponible.",
    gallery: "Galería",
  },
  booking: {
    title: "Reservar este tour",
    sub: "Elige fecha y personas. Sin pago ahora.",
    date: "Fecha", pickDate: "Elige una fecha", guests: "Personas",
    name: "Nombre completo", email: "Email", phone: "Teléfono / WhatsApp", notes: "Notas (opcional)",
    notesPh: "Hotel para la recogida, necesidades alimentarias, edades de los niños...",
    total: "Total estimado", perPerson: "{price} × {n} personas",
    submit: "Solicitar reserva", submitting: "Enviando solicitud...",
    noPayment: "Sin pago online. Comprobamos la disponibilidad y confirmamos por email en pocas horas.",
    successTitle: "¡Solicitud recibida!",
    successText: "Hemos enviado un resumen a {email}. Tu referencia es {ref}. Recibirás un email de confirmación en cuanto comprobemos la disponibilidad.",
    another: "Hacer otra reserva",
    chat: "¿Prefieres hablar? Chatea con una persona",
    chooseDate: "Elige una fecha",
    remove: "Quitar persona", add: "Añadir persona",
  },
  about: {
    eyebrow: "Nuestra historia",
    title: "Nacidos en Nápoles, pensados para viajeros",
    p1: "AMS Travel nace de un pequeño equipo de napolitanos que trabajó durante años con guías, conductores, bodegas y granjas familiares de toda Campania. Veíamos viajeros pagar precios de lujo por tours apresurados, o ahorrar y perderse el alma de la región.",
    p2: "Así que elegimos otro camino: solo tours por tierra, solo gente de confianza y precios que siguen siendo honestos. Cada tour se planifica como si fuera para nuestros amigos.",
    v1t: "Siempre locales", v1d: "Cada guía, conductor y anfitrión vive en Campania.",
    v2t: "Pequeños y personales", v2d: "Grupos reducidos y opciones privadas en cada tour.",
    v3t: "Honestos por diseño", v3d: "Precios transparentes, inclusiones claras, personas reales que responden.",
    cta: "Ver nuestros tours",
  },
  contact: {
    eyebrow: "Contacto",
    title: "Planifiquemos tus días en Campania",
    sub: "Escríbenos, llámanos o chatea por WhatsApp. Una persona real responderá en pocas horas.",
    name: "Tu nombre", email: "Email", phone: "Teléfono (opcional)", message: "Tu mensaje",
    messagePh: "Fechas, número de personas, lo que te encantaría ver...",
    send: "Enviar mensaje", sending: "Enviando...",
    sentTitle: "¡Mensaje enviado!", sentText: "Gracias. Te hemos enviado un email de confirmación y te responderemos muy pronto.",
    phoneL: "Teléfono", waL: "WhatsApp", emailL: "Email", addressL: "Oficina", hoursL: "Horario",
    chat: "Chatear con una persona",
  },
  footer: {
    tagline: "Tours premium por tierra en Campania a precios honestos. Pompeya, Nápoles, Herculano y Caserta.",
    tours: "Tours", company: "Empresa", contact: "Contacto",
    rights: "Todos los derechos reservados.", motto: "Campania por tierra",
  },
  wa: {
    aria: "Chatea con nosotros por WhatsApp", chat: "Chatea con una persona",
    default: "¡Hola AMS Travel! Me gustaría información sobre vuestros tours.",
    tour: "¡Hola AMS Travel! Me interesa el tour \"{tour}\". ¿Me podéis ayudar?",
  },
  err: { generic: "Algo salió mal. Inténtalo de nuevo o contáctanos por WhatsApp.", required: "Rellena los campos obligatorios." },
  notFound: { title: "Página no encontrada", back: "Volver al inicio" },
};

const fr = {
  how: {"eyebrow": "Comment ça marche", "title": "Trois étapes simples", "sub": "Pas d'acompte ni de plateforme : un contact direct avec ceux qui vous accompagneront.", "s1t": "Choisissez votre excursion", "s1d": "Parcourez nos excursions par la route en Campanie et choisissez celle qui vous inspire.", "s2t": "Envoyez votre demande", "s2d": "Choisissez la date et le nombre de personnes. Votre demande arrive directement à notre équipe, sans paiement en ligne.", "s3t": "Confirmation par email ou WhatsApp", "s3d": "Nous répondons en quelques heures avec la confirmation, l'heure de prise en charge et tous les détails.", "cta": "Voir les excursions"},
  extra: {"i4t": "Porte à porte, par la route", "i4d": "Prise en charge à l'hôtel, pas de ferry, pas d'attente au port. Nous conduisons, vous regardez par la fenêtre.", "stamp": "EXCURSIONS PAR LA ROUTE • CAMPANIE • PRIX HONNÊTES • ", "badge": "Service premium", "kicker": "Pas de bateau. Seulement les plus belles routes d'Italie."},
  nav: { tours: "Excursions", about: "À propos", contact: "Contact", book: "Réserver" },
  cat: { all: "Toutes les excursions", archaeology: "Archéologie", cities: "Villes et culture", food: "Gastronomie et vin", nature: "Nature et panoramas", coast: "Côte par la route" },
  card: { from: "Dès", pp: "par personne", discover: "Découvrir", hours: "{n} heures", max: "Max {n}" },
  hero: {
    eyebrow: "Excursions terrestres en Campanie",
    title1: "Service premium,",
    title2: "prix honnêtes",
    sub: "Pompéi, Naples, Herculanum et le Palais royal de Caserte avec des archéologues et guides locaux diplômés. Visites en groupe, en petit groupe ou privées, par la route, à prix clairs.",
    explore: "Voir les excursions",
    plan: "Organiser mes journées",
  },
  intro: {
    eyebrow: "Bienvenue chez AMS Travel",
    title: "La Campanie par la route, avec élégance",
    sub: "Nous sommes une équipe napolitaine qui connaît chaque route, chaque guide et chaque table familiale de la région. Nous créons des excursions qui semblent privées et sans effort, à des prix qui ont du sens.",
  },
  dates: {
    title: "Vous hésitez sur le jour ?",
    sub: "Donnez-nous vos dates et vos envies. Nous vous proposerons les meilleures excursions pour votre séjour, avec les prix, en quelques heures.",
    name: "Votre nom", email: "Email", from: "Du", to: "Au", guests: "Voyageurs", howMany: "Combien ?",
    prefs: "Qu'est-ce qui vous attire ? (facultatif)", prefsPh: "Sites antiques, gastronomie et vin, panoramas, journées tranquilles...",
    send: "Envoyer mes dates", sending: "Envoi...",
    sentTitle: "Merci !", sentText: "Nous avons reçu vos dates et vous avons envoyé un email de confirmation. Nous vous répondrons très vite.",
    pickDate: "Choisir une date",
  },
  philosophy: {
    eyebrow: "Notre promesse",
    title: "Service premium. Prix honnêtes.",
    sub: "Le luxe n'est pas un prix. C'est un guide qui connaît les rues calmes, un chauffeur toujours à l'heure et un déjeuner là où mangent les habitants.",
    i1t: "Guides locaux diplômés", i1d: "Archéologues, sommeliers et guides de randonnée campaniens, choisis personnellement par nous.",
    i2t: "En groupe ou en privé, à vous de choisir", i2d: "Visites partagées à prix honnêtes ou entièrement privées avec votre propre guide.",
    i3t: "Prix justes et transparents", i3d: "Prix par personne clairs, ce qui est inclus écrit noir sur blanc. Aucune surprise.",
  },
  featured: {
    eyebrow: "Excursions phares",
    title: "Le meilleur de la Campanie, par la route",
    sub: "Des rues de Pompéi aux ruelles de Naples, d'Herculanum au Palais royal de Caserte.",
    viewAll: "Voir toutes les excursions",
  },
  tailor: {
    eyebrow: "Sur mesure",
    title: "Vos journées, à votre façon",
    text: "Un van privé, un autre itinéraire ou plusieurs jours combinés ? Chaque excursion AMS Travel est personnalisable. Racontez-nous votre rêve, nous le rendons simple.",
    cta: "Créer mon excursion",
  },
  trust: {
    s1: "100%", l1: "Par la route", d1: "Pas de bateau, pas de ferry, pas de surprise météo. Seulement les plus belles routes et sentiers.",
    s2: "14", l2: "Visites guidées", d2: "Pompéi, Naples, Herculanum et Caserte, en groupe ou en privé.",
    s3: "Dès 22 €", l3: "Par personne", d3: "Une qualité premium à un prix qui laisse place à un déjeuner de plus.",
  },
  final: {
    eyebrow: "Commencez votre voyage",
    title: "Prêt à découvrir la Campanie ?",
    text: "Réservez en ligne en deux minutes ou parlez à une vraie personne. Nous répondons en quelques heures.",
    plan: "Organiser mon excursion",
    wa: "Écrire sur WhatsApp",
  },
  tours: {
    eyebrow: "Nos excursions",
    title: "Excursions terrestres en Campanie",
    sub: "Quatorze visites guidées à Pompéi, Naples, Herculanum et Caserte. Choisissez une date et envoyez votre demande en deux minutes : nous confirmons par e-mail.",
    empty: "Aucune excursion dans cette catégorie pour le moment.",
    clear: "Voir toutes les excursions",
    count: "{n} excursions",
  },
  detail: {
    back: "Toutes les excursions", durationL: "Durée", price: "Prix", pp: "par personne", details: "Détails",
    upTo: "Jusqu'à {n} voyageurs", duration: "{n} heures", meeting: "Point de rendez-vous",
    book: "Réserver cette excursion", wa: "WhatsApp", reply: "Nous répondons en quelques heures, de 8h00 à 21h00",
    experience: "L'expérience", yourDay: "Votre journée", included: "Ce qui est inclus", notIncluded: "Non inclus",
    goodToKnow: "Bon à savoir", faq: "Questions", notFound: "Cette excursion n'existe pas ou n'est plus disponible.",
    gallery: "Galerie",
  },
  booking: {
    title: "Réserver cette excursion",
    sub: "Choisissez la date et le nombre de voyageurs. Aucun paiement maintenant.",
    date: "Date", pickDate: "Choisir une date", guests: "Voyageurs",
    name: "Nom complet", email: "Email", phone: "Téléphone / WhatsApp", notes: "Remarques (facultatif)",
    notesPh: "Hôtel pour la prise en charge, régime alimentaire, âge des enfants...",
    total: "Total estimé", perPerson: "{price} × {n} voyageurs",
    submit: "Demander la réservation", submitting: "Envoi de la demande...",
    noPayment: "Aucun paiement en ligne. Nous vérifions la disponibilité et confirmons par email en quelques heures.",
    successTitle: "Demande reçue !",
    successText: "Nous avons envoyé un récapitulatif à {email}. Votre référence est {ref}. Vous recevrez un email de confirmation dès que la disponibilité sera vérifiée.",
    another: "Faire une autre réservation",
    chat: "Vous préférez parler ? Écrivez à une personne",
    chooseDate: "Veuillez choisir une date",
    remove: "Retirer un voyageur", add: "Ajouter un voyageur",
  },
  about: {
    eyebrow: "Notre histoire",
    title: "Nés à Naples, pensés pour les voyageurs",
    p1: "AMS Travel est née d'une petite équipe de Napolitains qui a travaillé pendant des années avec des guides, chauffeurs, domaines viticoles et fermes familiales de toute la Campanie. Nous voyions des voyageurs payer des prix de luxe pour des visites expédiées, ou économiser et passer à côté de l'âme de la région.",
    p2: "Nous avons donc choisi une autre voie : uniquement des excursions par la route, uniquement des personnes de confiance et des prix qui restent honnêtes. Chaque excursion est pensée comme pour nos propres amis.",
    v1t: "Toujours local", v1d: "Chaque guide, chauffeur et hôte vit en Campanie.",
    v2t: "Petit et personnel", v2d: "Petits groupes et options privées pour chaque excursion.",
    v3t: "Honnête par principe", v3d: "Prix transparents, inclusions claires, de vraies personnes qui répondent.",
    cta: "Voir nos excursions",
  },
  contact: {
    eyebrow: "Contact",
    title: "Organisons vos journées en Campanie",
    sub: "Écrivez-nous, appelez-nous ou discutez sur WhatsApp. Une vraie personne répondra en quelques heures.",
    name: "Votre nom", email: "Email", phone: "Téléphone (facultatif)", message: "Votre message",
    messagePh: "Dates, nombre de voyageurs, ce que vous aimeriez voir...",
    send: "Envoyer le message", sending: "Envoi...",
    sentTitle: "Message envoyé !", sentText: "Merci. Nous vous avons envoyé un email de confirmation et vous répondrons très vite.",
    phoneL: "Téléphone", waL: "WhatsApp", emailL: "Email", addressL: "Bureau", hoursL: "Horaires",
    chat: "Écrire à une personne",
  },
  footer: {
    tagline: "Excursions terrestres premium en Campanie à prix honnêtes. Pompéi, Naples, Herculanum et Caserte.",
    tours: "Excursions", company: "Société", contact: "Contact",
    rights: "Tous droits réservés.", motto: "La Campanie par la route",
  },
  wa: {
    aria: "Écrivez-nous sur WhatsApp", chat: "Écrire à une personne",
    default: "Bonjour AMS Travel ! J'aimerais des informations sur vos excursions.",
    tour: "Bonjour AMS Travel ! Je suis intéressé par l'excursion \"{tour}\". Pouvez-vous m'aider ?",
  },
  err: { generic: "Une erreur est survenue. Réessayez ou contactez-nous sur WhatsApp.", required: "Veuillez remplir les champs obligatoires." },
  notFound: { title: "Page introuvable", back: "Retour à l'accueil" },
};

const merge = (base, ext, ext3, ext4) => ({
  ...base, ...ext, ...ext3, ...ext4,
  nav: { ...base.nav, ...(ext.nav || {}) },
  booking: { ...base.booking, ...(ext3.booking || {}) },
  hero: { ...base.hero, eyebrow: ext.brand?.tagline || base.hero.eyebrow },
});

export const STRINGS = {
  en: merge(en, EXT.en, EXT3.en, EXT4.en), it: merge(it, EXT.it, EXT3.it, EXT4.it),
  es: merge(es, EXT.es, EXT3.es, EXT4.es), fr: merge(fr, EXT.fr, EXT3.fr, EXT4.fr),
};
